import { CATEGORY_LABELS } from "@/lib/shoppingConstants";

/**
 * CategoryChips — horizontal scrollable chips that filter the main shopping
 * list by category. Supports drag-and-drop reordering (handled by parent).
 *
 * Renders nothing when there are no items.
 */
export default function CategoryChips({
  items,
  categories,
  categoryCounts,
  activeCategory,
  onSelectCategory,
  chipDraggedIdx,
  chipDragOverIdx,
  setChipDraggedIdx,
  setChipDragOverIdx,
  onChipDrop,
}) {
  if (!categories || categories.length === 0) return null;
  const totalItems = (items || []).length;

  return (
    <div className="flex gap-2 mb-3 overflow-x-auto sm:flex-wrap scrollbar-thin -mx-2 px-2 pb-1 sm:mx-0 sm:px-0 sm:pb-0 print-hide" data-testid="shopping-category-chips">
      <button
        onClick={() => onSelectCategory("all")}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all border whitespace-nowrap flex-shrink-0 ${activeCategory === "all" ? "bg-navy-800 text-white border-navy-800" : "bg-white text-stone-600 border-stone-200 hover:bg-stone-50"}`}
        data-testid="shopping-chip-all"
      >
        Alle <span className="opacity-70">({totalItems})</span>
      </button>
      {categories.map((cat, idx) => {
        const isDragTarget = chipDragOverIdx === idx;
        return (
          <button
            key={cat}
            draggable
            onDragStart={(e) => { setChipDraggedIdx(idx); e.dataTransfer.effectAllowed = "move"; }}
            onDragOver={(e) => { e.preventDefault(); if (chipDragOverIdx !== idx) setChipDragOverIdx(idx); }}
            onDragLeave={() => { if (chipDragOverIdx === idx) setChipDragOverIdx(null); }}
            onDrop={(e) => { e.preventDefault(); onChipDrop(idx); }}
            onDragEnd={() => { setChipDraggedIdx(null); setChipDragOverIdx(null); }}
            onClick={() => onSelectCategory(cat)}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all border cursor-grab active:cursor-grabbing whitespace-nowrap flex-shrink-0 ${activeCategory === cat ? "bg-navy-800 text-white border-navy-800" : "bg-white text-stone-600 border-stone-200 hover:bg-stone-50"} ${isDragTarget && chipDraggedIdx !== idx ? "ring-2 ring-seawater-500 scale-105" : ""} ${chipDraggedIdx === idx ? "opacity-40" : ""}`}
            data-testid={`shopping-chip-${cat}`}
            title="Dra for å endre rekkefølge"
          >
            {CATEGORY_LABELS[cat] || cat} <span className="opacity-70">({categoryCounts[cat]})</span>
          </button>
        );
      })}
    </div>
  );
}
